import { render, staticRenderFns } from "./Tutors.vue?vue&type=template&id=8bc8ad5c&scoped=true&"
import script from "./Tutors.vue?vue&type=script&lang=js&"
export * from "./Tutors.vue?vue&type=script&lang=js&"
import style0 from "./Tutors.vue?vue&type=style&index=0&id=8bc8ad5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc8ad5c",
  null
  
)

export default component.exports